export const CampaignConstants = {
	SMS: 'SMS',
	Email:'Email',
	Voice:'Voice',
	Social:'Social',
	RunNow: 'runNow',
	Schedule: 'schedule',
	Recurring: 'recurring',
	Trigger: 'trigger',
}